var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "i-progress" }, [
    _c("span", {
      staticClass: "i-progress-inner",
      style: {
        transform: `scaleX(${_vm.currentRatio})`,
        backgroundColor: _vm.color,
        backgroundImage: _vm.backgroundImage,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }